import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'state/store-hooks';
import { locationCashierTheme } from 'utils/helper-functions/get-url-vars';
import { themeAppearanceMode } from '@pano-project/variables/theme-mode';
import { isPanoramicTheme } from '@pano-project/variables/is-panoramic-2-0-theme';
import {
  HeaderButtonsSettings,
  resolveHeaderButtons,
} from '@pano-project/variables/header-buttons';
import {
  embeddedAppearance,
  embeddedHeaderStyle,
  embeddedLayout,
  embeddedShowBackButton,
  embeddedShowCloseButton,
} from '@pano-project/variables/boot-header-settings';

export interface BootHeaderSettings extends HeaderButtonsSettings {
  shouldRender: boolean;
  headerStyle: string | null;
  layout: string | null;
  appearanceMode: string;
}

export const useBootHeaderSettings = (): BootHeaderSettings => {
  const { showBackButton, showCloseButton, headerStyle, layout, appearanceMode } = useAppSelector(
    (state: any) => {
      const initTheme = state.initTheme;
      const cs = initTheme?.theme_editor_settings?.customization_settings;
      return {
        showBackButton: cs?.show_back_button,
        showCloseButton: cs?.show_close_button,
        headerStyle: cs?.header_style,
        layout: cs?.layout,
        appearanceMode: initTheme?.cashier_appearance_mode,
      };
    },
    shallowEqual,
  );

  const resolvedLayout = layout ?? embeddedLayout;
  const resolvedHeaderStyle = headerStyle ?? embeddedHeaderStyle;

  const headerButtons = resolveHeaderButtons({
    showBackButton: showBackButton ?? embeddedShowBackButton,
    showCloseButton: showCloseButton ?? embeddedShowCloseButton,
    layout: resolvedLayout,
    headerStyle: resolvedHeaderStyle,
  });

  return {
    ...headerButtons,
    shouldRender: isPanoramicTheme && headerButtons.showAnyHeaderButton,
    headerStyle: resolvedHeaderStyle,
    layout: resolvedLayout,
    appearanceMode:
      appearanceMode ?? themeAppearanceMode(embeddedAppearance ?? 'system', locationCashierTheme),
  };
};
